{
  "translation": {
    "copyright": "© {{year}} The Savings Group, Inc.",
    "currency": {
      "aMonth": "${{amount}}/month"
    },
    "disclosures": {
      "alimony": "Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying this obligation.",
      "applicantIncome": "This should be your gross yearly income from your job, investments, pensions and or government benefits, all before any deductions for federal and state taxes and before any other payroll deductions. Most lenders require a minimum of $24,000 of total yearly income. Call <phone>{{phoneNumber}}</phone> if you have questions about your specific situation.",
      "coapplicantIncome": "This should be their gross yearly income from their job, investments, pensions and or government benefits, all before any deductions for federal and state taxes and before any other payroll deductions. Most lenders require a minimum of $24,000 of total yearly income. Call <phone>{{phoneNumber}}</phone> if you have questions about their specific situation.",
      "creditReportAcknowledgement": "By submitting this application, you acknowledge that you have read and agree to our <terms>Terms of Use</terms> and <privacy>Privacy Policy</privacy>; that you are at least 18 years of age and that all the information provided is true, correct and complete and you grant permission to {{brand}} and/or its Lenders to obtain a copy of your credit report.",
      "jointCredit": "By selecting to add a co-borrower, you are both indicating your intent to apply for credit jointly. Do not select the co-borrower field unless you desire to apply for joint credit.",
      "prequalAuthorization": "You understand that by checking this box you are providing written instructions under the Fair Credit Reporting Act authorizing {{brand}} and its participating lenders to obtain my personal credit profile and other information from credit reporting agencies solely for the credit pre-qualification options.",
      "smsOptIn": "By checking this box, you agree to receive transactional SMS messages from {{brand}} regarding your loan application status at the phone number provided. Message frequency varies based on application activity. Msg & data rates may apply. Text STOP to opt out at any time. Reply HELP for assistance.",
      "termsPrivacy": "By signing up, you agree to our <terms>Terms of Use</terms> and <privacy>Privacy Policy.</privacy>",
      "termsPrivacyReceipt": "By signing up, you agree to our <terms>Terms of Use</terms> and acknowledge the receipt of our <privacy>Privacy Policy.</privacy>"
    },
    "validation": {
      "phone": {
        "required": "Phone is required",
        "invalid": "Please enter a valid phone number",
        "applicantConflict": "Cannot be the same phone number as the applicant"
      },
      "firstName": {
        "required": "First name is required",
        "minLength": "Must be at least {{min}} letters",
        "invalid": "Must only contain letters, spaces, apostrophes and hyphens"
      },
      "lastName": {
        "required": "Last name is required",
        "minLength": "Must be at least {{min}} letters",
        "invalid": "Must only contain letters, spaces, apostrophes and hyphens"
      },
      "emailAddress": {
        "required": "Email is required",
        "invalid": "Please enter a valid email address",
        "applicantConflict": "Cannot be the same email address as the applicant"
      },
      "vin": {
        "invalidCharacters": "The VIN must contain only numbers and uppercase letters, excluding the letters \"I\", \"O\" & \"Q\".",
        "required": "VIN is required"
      },
      "plate": {
        "required": "License plate is required"
      },
      "state": {
        "required": "State is required"
      },
      "year": {
        "required": "Year is required"
      },
      "make": {
        "required": "Make is required"
      },
      "model": {
        "required": "Model is required"
      },
      "trim": {
        "required": "Trim is required"
      },
      "mileage": {
        "required": "Milleage is required",
        "invalid": "Please enter a valid number"
      },
      "payoffAmount": {
        "required": "Payoff amount is required",
        "min": "Must be a value greater than {{min}}",
        "max": "Must be a value less than {{max}}"
      },
      "purchasePrice": {
        "required": "Purchase price is required",
        "min": "Must be a value greater than {{min}}",
        "max": "Must be a value less than {{max}}"
      },
      "housingAmount": {
        "required": "Housing amount is required",
        "min": "Must be a value greater than or equal to {{min}}",
        "max": "Must be a value less than {{max}}"
      },
      "address": {
        "required": "Address is required"
      },
      "city": {
        "required": "City is required"
      },
      "zipCode": {
        "required": "Zip code is required",
        "minMax": "Must be {{minMax}} digits"
      },
      "employerName": {
        "required": "Employer name is required"
      },
      "jobTitle": {
        "required": "Job title is required"
      },
      "durationMonths": {
        "required": "Duration months is required"
      },
      "durationYears": {
        "required": "Duration years is required"
      },
      "grossAnnualIncome": {
        "required": "Gross annual income is required",
        "min": "Must be a value greater than or equal to {{min}}"
      },
      "employmentType": {
        "required": "Employment type is required"
      },
      "incomeType": {
        "required": "Income type is required"
      },
      "incomeFrequency": {
        "required": "Income frequency is required"
      },
      "incomeAmount": {
        "required": "Income amount is required",
        "min": "Must be a value greater than or equal to {{min}}"
      },
      "additionalIncome": {
        "required": "Additional income is required"
      },
      "dateOfBirth": {
        "required": "Date of birth is required",
        "invalid": "Please enter a valid date of birth",
        "futureDate": "Date of birth must be a past date"
      },
      "ssn": {
        "required": "Social security number is required",
        "invalid": "Please enter a valid social security number"
      },
      "terms": {
        "required": "Agreeing to the terms of use and privacy policy is required"
      },
      "prequalDisclosure": {
        "required": "Agreeing to the pre-qualification disclosure is required"
      },
      "smsOptIn": {
        "required": "Agreeing to receive SMS messages is required"
      },
      "file": {
        "formatInvalid": "{{fileName}}: incorrect file type",
        "sizeExceeded": "{{fileName}} larger than {{maxFileSize}}"
      },
      "mailCode": {
        "required": "Savings ID is required"
      }
    },
    "errors": {
      "parameter": {
        "APPLICATION_KEY_MISSING_OR_EXPIRED": "Activation link has expired, please sign in to continue.",
        "INVALID_APPLICATION_KEY": "Invalid activation link provided, please sign in to continue.",
        "INVALID_AUTHORIZATION_CODE": "We weren't able to finish signing you in automatically. Enter your phone number below to continue.",
        "INVALID_RATE_SELECTED": "Invalid rate selection, please sign in to continue.",
        "LOS_IMPORT_ERROR": "Please sign in to activate your application.",
        "MISSING_APPLICATION_KEY": "Unable to locate your activation link, please sign in to try again.",
        "MISSING_AUTHORIZATION_CODE": "We weren't able to finish signing you in automatically. Enter your phone number below to continue.",
        "MISSING_ENCODED_DATA": "Unable to locate you in our system, please sign in to continue.",
        "TOO_MANY_REQUESTS": "We couldn't sign you in automatically because of too many attempts. Wait a few minutes, then enter your phone number below to continue."
      },
      "deliverPin": {
        "statusMessage": {
          "403": "Your account has been temporarily locked",
          "404": "An account belonging to this phone number was not found. Please <signup>sign up</signup>",
          "409": "An account belonging to this phone number was found. Please <signin>sign in</signin>",
          "422": "Please verify your Phone number",
          "429": "Too many attempts. Please wait a few minutes and try again."
        },
        "errorCode": {
          "ACCOUNT_OWNERSHIP_UNVERIFIED": "An account is already registered with this email address. For your security, sign in with the phone number on that account.",
          "SMS_DELIVERY_UNKNOWN": "Your message was sent, but we're unable to confirm delivery. Please check that your number is correct.",
          "SMS_INVALID_NUMBER": "The phone number entered doesn't appear to be valid. Please check and update your number.",
          "SMS_LANDLINE": "This number appears to be a landline or is unreachable. Please provide a mobile number to receive messages.",
          "SMS_REGION_NOT_ENABLED": "We're unable to send messages to this phone number's region. Please contact support for assistance.",
          "SMS_UNKNOWN_DESTINATION": "We couldn't reach this phone number. Please double-check your number is correct and try again.",
          "SMS_UNKNOWN_ERROR": "Something went wrong delivering your message. Please try again or contact support if the issue persists.",
          "SMS_UNREACHABLE": "Your message couldn't be delivered. The phone may be off or out of range. We'll try again shortly.",
          "SMS_UNSUBSCRIBED": "This number has previously opted out of messages. To re-subscribe, reply START or contact support."
        },
        "defaultMessage": "There was an unexpected error attempting to send the verification code, please try again later"
      },
      "userAuthenticate": {
        "statusMessage": {
          "401": "Invalid code. Check the number and try again",
          "403": "Your account has reached the maximum number of failed login attempts and has been temporarily locked. Please try again in 15 minutes.",
          "404": "Invalid code. Check the number and try again",
          "429": "Too many attempts. Please wait a few minutes and try again.",
          "500": "There was an error attempting to verify the code. Please re-send it."
        },
        "errorCode": {
          "ACCOUNT_OWNERSHIP_UNVERIFIED": "We couldn't confirm this account belongs to you. Please sign in with the phone number on the account, or use the link you were sent."
        },
        "defaultMessage": "There was an unexpected error attempting to verify the code. Please try again."
      },
      "userCreate": {
        "statusMessage": {
          "401": "Invalid code. Check the number and try again",
          "403": "Too many incorrect codes. This phone number has been temporarily locked. Please try again in 15 minutes.",
          "404": "Invalid code. Check the number and try again",
          "429": "Too many attempts. Please wait a few minutes and try again.",
          "500": "There was an error attempting to verify the code. Please re-send it."
        },
        "defaultMessage": "There was an unexpected error attempting to verify the code. Please try again."
      },
      "userExists": {
        "statusMessage": {
          "429": "Too many attempts. Please wait a few minutes and try again."
        }
      },
      "userUpdate": {
        "defaultMessage": "Unable to update the user. Please try again later."
      },
      "fetchVehicleBy": {
        "statusMessage": {
          "404": "Vehicle details not found"
        },
        "defaultMessage": "Unable to make the request. Please try again later."
      },
      "fetchVehicleMakes": {
        "defaultMessage": "Unable to make the request. Please try again later."
      },
      "fetchVehicleModels": {
        "defaultMessage": "Unable to make the request. Please try again later."
      },
      "fetchVehicleTrims": {
        "defaultMessage": "Unable to make the request. Please try again later."
      },
      "apply": {
        "defaultMessage": "Unable to make the request. Please try again later.",
        "statusMessage": {
          "409": "It appears you already have an active application for this vehicle. <dashboard>Click here to resume.</dashboard>"
        }
      },
      "fetchVehicles": {
        "defaultMessage": "An unexpected error occurred when attempting to load vehicles. Please try again later."
      },
      "fetchVehicleByApplicationAutopayNumber": {
        "defaultMessage": "An unexpected error occurred when attempting to load the vehicle. Please try again later."
      },
      "fetchVehicleById": {
        "defaultMessage": "An unexpected error occurred when attempting to load the vehicle. Please try again later."
      },
      "syncIncome": {
        "defaultMessage": "Unable to make the request. Please try again later."
      },
      "syncResidence": {
        "defaultMessage": "Unable to make the request. Please try again later."
      },
      "submitApplication": {
        "defaultMessage": "An unexpected error occurred when attempting to submit your application. Please try again later.",
        "dateOfBirthInvalidMessage": "An invalid date of birth was provided. Please correct it and try again.",
        "statusMessage": {
          "409": "Our records indicate that you have already submitted this application. Please check your dashboard for next steps."
        }
      },
      "createCoapplicant": {
        "defaultMessage": "Unable to make the request. Please try again later."
      },
      "syncCoapplicant": {
        "defaultMessage": "Unable to make the request. Please try again later."
      },
      "disableCoapplicant": {
        "defaultMessage": "Unable to make the request. Please try again later."
      },
      "updateVehicle": {
        "defaultMessage": "Unable to update the vehicle. Please try again later."
      },
      "retryFailedSubmission": {
        "defaultMessage": "Unable to make the request. Please try again later."
      },
      "fetchMailCode": {
        "statusMessage": {
          "404": "Savings ID not recognized. Please check your mailer and try again.",
          "429": "Too many attempts. Please wait a few minutes and try again."
        },
        "defaultMessage": "An unexpected error occurred when attempting to pull your offer. Please try again later."
      }
    },
    "imageAlts": {
      "logo": "The Savings Group",
      "menu": "Toggle menu",
      "heroErrorWithSmoke": "Illustration of a person using a computer with smoke coming out of it",
      "heroReference": "Illustration of a person holding a phone receiving an SMS message to sign-into their account",
      "heroSearching": "Illustration of a person holding a telescope searching for a better auto loan",
      "heroWithCamera": "Illustration of a person taking a self portrait with a camera",
      "heroesCheering": "Illustration of a group of people cheering",
      "selectedVehicle": "Vehicle selected for financing",
      "applicationVehicle": "Vehicle belonging to the application",
      "heroSuccess": "Illustration of a person",
      "heroMeditation": "Illustration of a person meditating",
      "heroDesigner": "Illustration of a person designing on a computer",
      "vehicleSUVSideView": "Side view of an SUV",
      "vehicleSUVTopView": "Top view of an SUV",
      "reviews": "Trustworthy customer reviews on Google"
    },
    "verificationStatus": {
      "complete": "Complete",
      "optional": "Optional",
      "requested": "Requested"
    },
    "verifications": {
      "applicantDriversLicense": {
        "name": "Applicant driver's license",
        "headline": "Upload your driver's license",
        "copy": "Please upload a clear photo or copy of the applicant's state issued Driver License. Please ensure they are valid and up to date."
      },
      "coapplicantDriversLicense": {
        "name": "Co-applicant driver's license",
        "headline": "Upload their driver's license",
        "copy": "Please upload a clear photo or copy of the co-applicant's state issued Driver License. Please ensure they are valid and up to date."
      },
      "proofOfAutoInsurance": {
        "name": "Proof of auto insurance",
        "headline": "Proof of auto insurance",
        "copy": "Please provide a clear photo of your vehicle's proof of insurance. These documents will need to be valid and up to date."
      },
      "registrationCard": {
        "name": "Registration card",
        "headline": "Upload your registration card",
        "copy": "Please provide a clear photo of your vehicle's registration card. These documents will need to be valid and up to date."
      },
      "photoOfOdometer": {
        "name": "Photo of odometer",
        "headline": "Upload your odometer reading",
        "copy": "Please provide a clear photo of your vehicle's latest odometer reading as it appears currently in your vehicle."
      },
      "proofOfIncome": {
        "name": "Proof of Income",
        "headline": "Upload your proof of income",
        "copy": "Please provide a clear photo or copy of the applicant's most recent payment statement. This document will need to be valid and up to date."
      },
      "coapplicantProofOfIncome": {
        "name": "Co-applicant proof of income",
        "headline": "Upload their proof of income",
        "copy": "Please provide a clear photo or copy of the co-applicant's most recent payment statement. This document will need to be valid and up to date."
      },
      "additionalDocuments": {
        "name": "Additional documents",
        "headline": "Upload any additional documents",
        "copy": "Please use this to upload any additional documents requested by your loan specialist."
      }
    },
    "files": {
      "frontOfLicense": "Front of license",
      "backOfLicense": "Back of license",
      "proofOfAutoInsurance": "Proof of auto insurance",
      "registrationCard": "Registration card",
      "photoOfOdometer": "Photo of odometer",
      "mostRecentPaystub": "Most recent pay stub",
      "additionalDocument": "Additional document"
    },
    "tasks": {
      "applicant": {
        "title": "Help us with any missing info in your application",
        "description": "Help us finalize any missing information about yourself and your financial situation. We'll need this information to accurately process your application.",
        "actionTitle": "Resume application"
      },
      "verifications": {
        "title": "Now let's upload your required verifications",
        "description": "Your application is currently in review and a decision will be made shortly. To expedite the process, please continue to upload your verification documents.",
        "actionTitle": "Upload documents"
      },
      "complete": {
        "title": "Congratulations, looks like you're all caught up",
        "description": "You've completed all the necessary requirements for our team to advance your application. Should we need any additional information, we'll reach out.",
        "actionTitle": "Check back later"
      },
      "canceled": {
        "title": "It appears this application is no longer active",
        "description": "Your application has either expired or been canceled. To begin a new one, use the button provided below. If you believe this message is in error, please contact us.",
        "actionTitle": "New application"
      },
      "failed": {
        "title": "Something's not quite right",
        "description": "We were unable to import your application successfully. Please try again, and if the issue persists, please contact our team for help.",
        "actionTitle": "Retry"
      },
      "queued": {
        "title": "Working on your application...",
        "description": "We are currently processing your application and will be ready shortly. We appreciate your patience and will notify you as soon as it's ready.",
        "actionTitle": "Learn more"
      },
      "handoff": {
        "title": "You're all set for now",
        "description": "You've completed everything on your end. A member of the {{brand}} team will be in touch to walk you through the next steps and help finalize your application.",
        "actionTitle": "Contact us"
      }
    },
    "applicationDescription": {
      "brand": "{{brand}}",
      "brandWithId": "{{brand}} #{{id}}",
      "inSubmission": "Preparing your application"
    },
    "applicationProgress": {
      "newApplication": {
        "description": "Great start! You've taken the first step to improving your financial journey. Our dedicated team is standing by should you need help through the process.",
        "title": "New application"
      },
      "completeApplication": {
        "description": "Please help us fill in any missing information regarding your loan application. When ready, we'll submit to our network of lenders for approval.",
        "title": "Complete application"
      },
      "submittedToLender": {
        "description": "The lender is reviewing your application and expected to make a decision shortly. In the meantime, upload your verification documents to expedite the review process.",
        "title": "Submitted to lender"
      },
      "approvedByLender": {
        "description": "Your application has been approved by the lender. Be sure to complete all of the required tasks to support the advancement of your application.",
        "title": "Approved by lender"
      },
      "preparingContracts": {
        "description": "Your contract is currently being prepared by our team of processors. Once ready, we'll require your signature to finalize the new refinance terms with the lender.",
        "title": "Preparing contracts"
      },
      "signingContracts": {
        "description": "We're ready for you! Your contracts have been prepared and ready for your signature. Please review and sign the final paperwork required to finalize your new loan.",
        "title": "Sign contracts"
      },
      "reviewingDocuments": {
        "description": "Our processors are taking a look at your current verifications. If there's anything outstanding we may request follow up items before we get a final review from the lender.",
        "title": "Reviewing documents"
      },
      "finalizingStips": {
        "description": "The lender has requested for additional information to advance the approval process. Please fulfill any requests for information to proceed with your approval.",
        "title": "Finalize verifications"
      },
      "waitingOnFunding": {
        "description": "Your finalized loan package has been sent to the lender for funding. Once they have a chance to review, the lender will come back with a decision.",
        "title": "Waiting on funding"
      },
      "lenderFunded": {
        "description": "That's everything! Your loan application has been approved, and we are in the process of working with your current lender to transfer the payoff balance.",
        "title": "Lender funded"
      }
    },
    "applicationProgressModal": {
      "applicationProgress": "Application progress",
      "close": "Close"
    },
    "applicationUpdatedModal": {
      "title": "Your application needs to reload",
      "content": "To apply the latest updates and features, your application needs to reload. Please click the button below to refresh and continue using the app with the latest updates to your application.",
      "reloadPage": "Reload page"
    },
    "applicationQueuedLearnModal": {
      "title": "Working on your application",
      "content": "In some cases, finalizing an application may take a little extra time (usually just a few minutes). Once it's complete, we'll clearly signal the next steps. If it seems like the process is taking longer than expected, feel free to reach out to our team using the “Contact” section. We're here to help!",
      "close": "Close"
    },
    "navigation": {
      "garage": "Garage",
      "account": "Account",
      "signout": "Sign-out"
    },
    "additionalIncome": {
      "yes": "Yes",
      "no": "No"
    },
    "incomeFrequency": {
      "annually": "Annually",
      "monthly": "Monthly",
      "semiMonthly": "Semi-monthly",
      "biWeekly": "Bi-weekly",
      "weekly": "Weekly"
    },
    "incomeStatus": {
      "hasAdditionalIncome": "Has additional income",
      "noAdditionalIncome": "No additional income"
    },
    "incomeType": {
      "aidForDependentChildren": "Aid for dependent children",
      "childSupport": "Child support",
      "costOfLivingAllowance": "Cost of living allowance",
      "disability": "Disability",
      "employment": "Employment",
      "militaryBasicAllowanceForSubsistence": "Military basic allowance for subsistence",
      "municipalBondInterest": "Municipal bond interest",
      "nonTaxableSources": "Non-taxable sources",
      "other": "Other",
      "publicAssistance": "Public assistance",
      "rentalIncome": "Rental income",
      "secondaryEmployment": "Secondary employment",
      "socialSecurity": "Social security",
      "supplementalSecurityIncome": "Supplemental security income",
      "unknown": "Unknown",
      "workmansCompensation": "Workman's compensation"
    },
    "previousEmploymentType": {
      "fullTime": "Full time",
      "partTime": "Part time",
      "selfEmployed": "Self-employed",
      "military": "Military",
      "student": "Student",
      "homemaker": "Homemaker",
      "retired": "Retired",
      "disability": "Disability",
      "other": "Other"
    },
    "residenceType": {
      "own": "Own",
      "rent": "Rent",
      "other": "Other",
      "unknown": "Unknown"
    },
    "residenceDuration": {
      "moreThan2Years": "More than 2 years",
      "lessThan2Years": "Less than 2 years"
    },
    "employmentDuration": {
      "moreThan1Year": "More than 1 year",
      "lessThan1Year": "Less than 1 year"
    },
    "employmentStatus": {
      "employed": "Employed",
      "unemployed": "Unemployed"
    },
    "employmentType": {
      "disability": "Disability",
      "fullTime": "Full time",
      "homemaker": "Homemaker",
      "military": "Military",
      "other": "Other",
      "partTime": "Part time",
      "retired": "Retired",
      "selfEmployed": "Self-employed",
      "student": "Student"
    },
    "errorBoundary": {
      "title": "Something went wrong on our end..",
      "subtitle": "Something went wrong trying to display this page.<0></0>Try coming back to it later.",
      "dashboard": "Dashboard"
    },
    "dropzone": {
      "active": "Drop the files here...",
      "fileInput": "Upload document",
      "inactive": "Click here to <0>upload a file or take a photo<0>",
      "invalid": "Drop the files here, some will be rejected...",
      "rejectedFileDuplicate": "already submitted",
      "rejectedFileType": "incorrect file type",
      "rejectedFileTooLarge": "file too large"
    },
    "rate": {
      "estimatedPayment": "est. payment*",
      "payment": "payment",
      "estimatedApr": "est. apr*",
      "apr": "apr",
      "term": "term",
      "monthlyPaymentAmount": "${{amount}}/mo",
      "aprPercent": "{{percent}}%",
      "termMonths": "{{months}} months"
    },
    "mailCodeSavingsOffer": {
      "estOriginalPayment": "Est <0>original</0> payment",
      "estOriginalPaymentAmount": "${{amount}}/mo",
      "estRefinancePayment": "Est <0>refinance</0> payment",
      "estRefinancePaymentAmount": "${{amount}}/mo",
      "estSavings": "Est <0>savings</0> amount",
      "estSavingsAmount": "-${{amount}}/mo"
    },
    "banners": {
      "refandi": {
        "title": "Unlock more ways to save!",
        "subtitle": "Upload your dealership loan documents and discover new ways to save. On average, customers get over $1,000 refunded when they refinance!",
        "savingsAmount": "$1,000",
        "estSavings": "est. savings",
        "getStarted": "Get started",
        "disclaimer": "Protection provided by The Savings Group, LLC"
      }
    },
    "NotFoundPage": {
      "title": "Sorry, we couldn't find that page",
      "subtitle": "It may have been removed or the link might be broken. Let's get you\nback home where you can manage your applications.",
      "returnHome": "Return home"
    },
    "SignInPage": {
      "title": "Welcome back!",
      "subtitle": "We'll send you a six-digit verification code to sign into your account",
      "phoneNumber": "Phone Number",
      "continue": "Continue",
      "noAccount": "Don't have an account?",
      "signup": "Sign up"
    },
    "SignInPinVerifyPage": {
      "title": "Enter the 6-digit code",
      "subtitle": "Please enter the code that we texted to you at <0>{{phoneNumber}}</0>",
      "resendCode": "Resend code",
      "resendCodeDelay": "Retry {{delay}}s",
      "codeSent": "New code sent!",
      "signup": "Sign up"
    },
    "SignUpPage": {
      "title": {
        "default": "Find vehicle financing options built around your goals",
        "REFINANCE": "See if you could be paying less, in minutes.",
        "PURCHASE": "Get pre-qualified and shop with confidence for your next vehicle",
        "LEASE_BUYOUT": "Finance the buy out of your lease, hassle free"
      },
      "subtitle": {
        "default": {
          "firstLine": "Quick and easy, no commitment",
          "secondLine": "Compare offers from 150+ lenders",
          "thirdLine": "No spam calls, only updates"
        },
        "REFINANCE": {
          "firstLine": "Quick and easy, no commitment",
          "secondLine": "Compare offers from 150+ lenders",
          "thirdLine": "No spam calls, only updates"
        },
        "PURCHASE": {
          "firstLine": "Save time at the dealership",
          "secondLine": "Compare offers from 150+ lenders",
          "thirdLine": "No spam calls, only updates"
        },
        "LEASE_BUYOUT": {
          "firstLine": "Sign your documents from anywhere",
          "secondLine": "Dedicated advisor to guide every step",
          "thirdLine": "Nationwide financing available"
        }
      },
      "submitButton": {
        "default": "Get Started",
        "REFINANCE": "Check My Rate",
        "PURCHASE": "Get Pre-Qualified",
        "LEASE_BUYOUT": "Explore My Options"
      },
      "refandiSubtitle": "Sign up to view potential savings, replacement coverage options, and manage your refund. There is no obligation or credit check required.",
      "signin": "Sign in",
      "firstName": "First Name",
      "lastName": "Last Name",
      "phone": "Phone",
      "email": "Email"
    },
    "SignUpPinVerifyPage": {
      "title": "Enter the 6-digit code",
      "subtitle": "Please enter the code that we texted to you at <0>{{phoneNumber}}</0>",
      "resendCode": "Resend code",
      "resendCodeDelay": "Retry {{delay}}s",
      "codeSent": "New code sent!",
      "signup": "Sign up"
    },
    "SignUpReturningUser": {
      "title": "Are you a returning user?",
      "subtitle": "It appears an account is already registered with these details. Click below to sign in.",
      "ownershipUnverifiedTitle": "We found an existing account",
      "ownershipUnverifiedSubtitle": "We found an account with this email address, but it hasn't been activated yet. To keep it secure, you'll need to use the activation link we emailed you about your application. Check your inbox or spam folder.",
      "phone": "Phone",
      "email": "Email",
      "back": "Back",
      "signin": "Sign in"
    },
    "SignOutPage": {
      "title": "You've been signed out.",
      "subtitle": "We'll send you a six-digit verification code to sign into your account",
      "phoneNumber": "Phone Number",
      "continue": "Continue",
      "noAccount": "Don't have an account?",
      "signup": "Sign up"
    },
    "ActivationPage": {
      "titleFull": "Welcome {{firstName}},\nfrom {{displayLabel}}.",
      "titleNameOnly": "Welcome {{firstName}},\nlet's activate your account.",
      "titleLabelOnly": "Welcome savings expert,\nfrom {{displayLabel}}.",
      "titleDefault": "Welcome savings expert,\nlet's activate your account",
      "subtitle": "Please verify your phone number, you'll use this to access your account.",
      "offerSubtitle": "Congrats you're pre-qualified for the following rate:",
      "phoneNumber": "Phone Number",
      "agreeToFollowing": "I agree to the following",
      "agreeToFollowingCoapplicant": "I and my Co-applicant agree to the following",
      "continue": "Continue"
    },
    "ActivationPinVerifyPage": {
      "title": "Enter the 6-digit code",
      "subtitle": "Please enter the code that we texted to you at <0>{{phoneNumber}}</0>",
      "resendCode": "Resend code",
      "resendCodeDelay": "Retry {{delay}}s",
      "codeSent": "New code sent!"
    },
    "ApplicationUpdatePage": {
      "title": {
        "default": "Welcome back!",
        "withDisplayLabel": "Welcome back,\nfrom {{displayLabel}}!"
      },
      "subtitle": {
        "default": "Login to view your application updates.",
        "WELCOME_BACK": "Login to view your application updates.",
        "HAS_APPROVAL": "Login to view your application updates.",
        "TERMS_UPDATED": "The terms of your auto loan have been updated. Please log in to review.",
        "EDOCS_SIGNED": "Your eDocuments are complete and currently being reviewed. Please log in to review.",
        "LENDER_FUNDED": "Your loan application has been approved, and we are in the process of transferring the payoff balance. Please log in to review."
      },
      "phoneNumber": "Phone Number",
      "continue": "Continue"
    },
    "MailCodePage": {
      "title": "Welcome to {{brand}},\nplease enter your <0>Savings ID</0>.",
      "subtitle": "Enter the <0>Savings ID</0> you received in the mail to locate your personalized refinance offer.",
      "savingsId": "Savings ID",
      "continue": "Continue",
      "missingSavingsId": "I don't have a Savings ID"
    },
    "MailCodeOfferPage": {
      "title": {
        "SAVINGS": "{{firstName}}, you're pre-qualified for the following savings!",
        "RATE": "{{firstName}}, you're pre-qualified for the following offer!"
      },
      "subtitle": "You have been pre-approved for up to ${{amount}}.",
      "continue": "Continue"
    },
    "MailCodeActivationPage": {
      "title": {
        "default": "Let's secure your savings.",
        "REFINANCE": "Let's secure your savings.",
        "PURCHASE": "Let's secure your rate.",
        "LEASE_BUYOUT": "Let's secure your rate."
      },
      "subtitle": {
        "default": "Just add your phone and email to create your account and lock in your personalized refinance offer.",
        "REFINANCE": "Just add your phone and email to create your account and lock in your personalized refinance offer.",
        "PURCHASE": "Just add your phone and email to create your account and lock in your personalized purchase offer.",
        "LEASE_BUYOUT": "Just add your phone and email to create your account and lock in your personalized lease-buyout offer."
      },
      "firstName": "First Name",
      "lastName": "Last Name",
      "phone": "Phone",
      "email": "Email",
      "continue": "Continue"
    },
    "MailCodePinVerifyPage": {
      "title": "Enter the 6-digit code",
      "subtitle": "Please enter the code that we texted to you at <0>{{phoneNumber}}</0>",
      "resendCode": "Resend code",
      "resendCodeDelay": "Retry {{delay}}s",
      "codeSent": "New code sent!"
    },
    "PreviewOfferPage": {
      "title": {
        "default": "Here to bring you a better car payment.",
        "REFINANCE": "{{brand}} and {{displayLabel}} are working together to bring you a better car payment.",
        "PURCHASE": "{{brand}} and {{displayLabel}} are working together to help you secure competitive financing for your vehicle purchase.",
        "LEASE_BUYOUT": "{{brand}} and {{displayLabel}} have partnered to make buying your leased vehicle easier than ever."
      },
      "subtitle": "You are pre-approved up to ${{amount}}",
      "continue": "Continue",
      "disclaimer": "*Annual Percentage Rate (APR), monthly payment and term of loan estimates represents the average available rates among lenders in The Savings Group's lender network across various ranges of credit. These rates assume a loan to retail value ratio (LTV) of no more than 125% and a debt to income ratio (DTI) of no more than 50%. In addition to an individual's LTV and DTI, the actual APR you may receive is dependent upon many factors evaluated at the time of application, which may include, among other factors, credit score, loan amount, loan term, vehicle information, credit usage and history. All loans are subject to credit review and approval. Estimated APRs may not be available in the geographical area of your residence. While efforts have been made to maintain accurate information, the estimated APR or other terms presented do not bind any lender. Lenders generally have a range of available APRs (for example, a lender's range might be 2% to 24%) and only borrowers with excellent credit will qualify for the lowest rate available."
    },
    "PreviewActivationPage": {
      "title": "Let's secure your rate.",
      "subtitle": "Just add your phone and email to create your account and lock in your personalized offer.",
      "firstName": "First Name",
      "lastName": "Last Name",
      "phone": "Phone",
      "email": "Email",
      "continue": "Continue"
    },
    "PreviewPinVerifyPage": {
      "title": "Enter the 6-digit code",
      "subtitle": "Please enter the code that we texted to you at <0>{{phoneNumber}}</0>",
      "resendCode": "Resend code",
      "resendCodeDelay": "Retry {{delay}}s",
      "codeSent": "New code sent!"
    },
    "DashboardGaragePage": {
      "title": {
        "default": "Welcome back.",
        "withName": "Welcome back, {{firstName}}."
      },
      "subtitle": "Select from your applications to view its status and your next steps.",
      "newApplication": "Create new",
      "empty": {
        "title": "No applications...",
        "subtitle": "Click the button below to get started."
      },
      "refandi": {
        "description": "Continue your refund",
        "applicationDescription": "Find out how much you can save!"
      }
    },
    "DuplicateApplicationPage": {
      "title": "Good news. We're already on it.",
      "subtitle": "It looks like you've already submitted an application for your {{vehicle}}, and our team is actively working on it. To avoid duplicate processing, we'll continue with your original application and keep this submission for reference. If anything has changed or you have questions, please contact your loan specialist.",
      "brandChangeTitle": "You're already in good hands.",
      "brandChangeSubtitle": "It looks like you already have an active application for your {{vehicle}} with one of our other brands. Since {{duplicateBrand}} and {{activeBrand}} are both part of The Savings Group, you'll receive access to the same great lender network and customer support regardless of which brand you're working with.",
      "notice": "No further action is needed on your part. We'll continue processing your existing application and keep this submission for reference.",
      "account": "Go to my account",
      "defaultVehicle": "vehicle"
    },
    "DashboardApplicationPage": {
      "progress": "Progress",
      "viewAll": "View all",
      "noInformationAvailable": "No information available",
      "contact": "Contact",
      "name": "Name",
      "phone": "Phone",
      "email": "Email",
      "otherWaysToSave": "Other ways to save"
    },
    "ApplyPage": {
      "title": "Welcome, {{firstName}}.\nLet's start on your application.",
      "subtitle": "Provide your vehicle details to help us offer you the best financing options tailored to your needs.",
      "continue": "Continue",
      "resume": "Resume"
    },
    "ApplyApplicationTypePage": {
      "title": "Let's get started",
      "subtitle": "To get started, choose the type of vehicle financing that best suits your needs.",
      "continue": "Continue",
      "refinance": "Refinance",
      "leaseBuyout": "Lease buyout",
      "purchase": "Purchase"
    },
    "ApplyRefinanceGoalPage": {
      "title": "Set your refinance goal",
      "subtitle": "Tell us what you aim to achieve with your refinance to help us tailor the best options for you.",
      "continue": "Continue",
      "lowerPayment": "Lower payment",
      "lowerRate": "Lower rate",
      "checkingOptions": "Checking my options"
    },
    "ApplyPurchaseTypePage": {
      "title": "Select purchase type",
      "subtitle": "Choose whether you will be purchasing from a dealer or a private party to proceed.",
      "continue": "Continue",
      "dealer": "Dealer",
      "privateParty": "Private seller"
    },
    "ApplyVehicleConditionPage": {
      "title": "Select vehicle condition",
      "subtitle": "Indicate if you are purchasing a new or used vehicle to help us tailor your financing options.",
      "continue": "Continue",
      "new": "New",
      "used": "Used"
    },
    "ApplyVehicleSelectionPage": {
      "title": "Choose from your vehicles",
      "subtitle": "Select the vehicle you want to refinance from the list below, or click the button at the bottom to enter it manually.",
      "continue": "Continue",
      "enterManually": "I don't see my vehicle"
    },
    "ApplySearchVehiclePage": {
      "title": "Let's find your vehicle",
      "subtitle": "Tell us how you would like to search for your vehicle to get started.",
      "continue": "Continue",
      "byVin": "By VIN",
      "byLicensePlate": "By license plate",
      "byMakeModel": "By make & model"
    },
    "ApplySearchVinPage": {
      "title": "Enter your vehicle's VIN",
      "subtitle": "Provide your Vehicle Identification Number (VIN) to help us locate your car.",
      "continue": "Continue",
      "searching": "Searching",
      "vin": "VIN"
    },
    "ApplySearchPlatePage": {
      "title": "Enter your vehicle's plate",
      "subtitle": "Provide your license plate information to help us locate your car.",
      "continue": "Continue",
      "searching": "Searching",
      "plate": "License plate",
      "state": "State"
    },
    "ApplySearchYearPage": {
      "title": "Select your vehicle's year",
      "subtitle": "Choose the year of your vehicle to narrow down the search.",
      "continue": "Continue"
    },
    "ApplySearchMakePage": {
      "title": "Select your vehicle's make",
      "subtitle": "Choose the make of your vehicle to continue the search.",
      "continue": "Continue"
    },
    "ApplySearchModelPage": {
      "title": "Select your vehicle's model",
      "subtitle": "Choose the model of your vehicle to complete the search.",
      "continue": "Continue"
    },
    "ApplyConfirmVehiclePage": {
      "subtitle": "Verify your vehicle details and provide any remaining info to proceed with your application.",
      "trim": "Trim",
      "mileage": "Estimated mileage",
      "payoffAmount": "Estimated payoff amount",
      "purchasePrice": "Estimated purchase price",
      "continue": "Continue"
    },
    "ApplicantPage": {
      "title": "Let's check for savings on your {{vehicle}}.",
      "subtitle": "We'll need to collect some additional details to help us offer you the widest range of financing options tailored to your needs.",
      "continue": "Continue"
    },
    "ApplicantResidenceTypePage": {
      "title": "Select your residence type",
      "subtitle": "Choose the type of residence that best describes your current living situation.",
      "continue": "Continue",
      "own": "Own",
      "rent": "Rent",
      "other": "Other"
    },
    "ApplicantResidenceDetailsPage": {
      "title": "Enter your residence details",
      "subtitle": "Provide your address and the portion of the housing payment that only you are responsible for.",
      "continue": "Continue",
      "housingAmount": "Housing amount",
      "residenceLineOne": "Address",
      "residenceLineTwo": "Apt, unit",
      "residenceCity": "City",
      "residenceState": "State",
      "zip": "Zip"
    },
    "ApplicantResidenceDurationPage": {
      "title": "Have you lived here for more than two years?",
      "subtitle": "If you have lived at your current address for less than two years, we'll need your previous residence details.",
      "yes": "Yes",
      "no": "No",
      "continue": "Continue"
    },
    "ApplicantPreviousResidencePage": {
      "title": "Enter previous residence details",
      "subtitle": "Provide your previous address and other details to help us verify your previous residence.",
      "continue": "Continue",
      "residenceLineOne": "Address",
      "residenceLineTwo": "Apt, unit",
      "residenceCity": "City",
      "residenceState": "State",
      "zip": "Zip"
    },
    "ApplicantEmploymentStatusPage": {
      "title": "Select your employment status",
      "subtitle": "Choose whether you are currently employed or not employed to help us understand your financial picture.",
      "yes": "Employed",
      "no": "Not employed",
      "continue": "Continue"
    },
    "ApplicantEmploymentTypePage": {
      "title": "Specify your employment type",
      "subtitle": "Indicate the option that best describes your financial picture. If you earn additional income, you can claim it in the next steps.",
      "fullTime": "Full time",
      "partTime": "Part time",
      "selfEmployed": "Self-employed",
      "military": "Military",
      "continue": "Continue"
    },
    "ApplicantUnemploymentTypePage": {
      "title": "Specify your employment type",
      "subtitle": "Indicate the option that best describes your financial picture. If you earn additional income, you can claim it in the next steps.",
      "disability": "Disability",
      "homemaker": "Homemaker",
      "retired": "Retired",
      "student": "Student",
      "other": "Other",
      "continue": "Continue"
    },
    "ApplicantEmploymentDetailsPage": {
      "title": "Enter your employment details",
      "subtitle": "Provide information about your employer, job title, and income to help us better understand your financial picture.",
      "employerName": "Employer name",
      "jobTitle": "Job title",
      "grossAnnualIncome": "Gross annual income",
      "continue": "Continue"
    },
    "ApplicantUnemploymentDetailsPage": {
      "title": "Enter your current income",
      "subtitle": "Provide information about your income to better help us understand your financial picture.",
      "grossAnnualIncome": "Gross annual income",
      "continue": "Continue"
    },
    "ApplicantEmploymentDurationPage": {
      "title": "Have you worked here for more than a year?",
      "subtitle": "If you have worked at your current employer for less than a year, we'll need your previous employment details.",
      "yes": "Yes",
      "no": "No",
      "continue": "Continue"
    },
    "ApplicantPreviousEmploymentPage": {
      "title": "Provide previous employment",
      "subtitle": "Provide your previous employment and other details to help us verify your previous employment.",
      "employmentType": "Employment type",
      "employerName": "Employer name",
      "jobTitle": "Job title",
      "grossAnnualIncome": "Gross annual income",
      "continue": "Continue"
    },
    "ApplicantAdditionalIncomePage": {
      "title": "Do you have additional income?",
      "subtitle": "Let us know if you have any additional sources of income to help us better understand your financial picture.",
      "yes": "Yes",
      "no": "No",
      "continue": "Continue"
    },
    "ApplicantAddCoapplicantPage": {
      "title": "Add a Co-Applicant?",
      "subtitle": "Include a co-applicant to strengthen your application and improve your chances of approval.",
      "yes": "Yes",
      "no": "No",
      "continue": "Continue"
    },
    "ApplicantIncomeDetailsPage": {
      "title": "Provide your income details",
      "subtitle": "Enter the details of your additional income to ensure we have a complete picture of your finances.",
      "incomeType": "Income type",
      "incomeFrequency": "Income frequency",
      "incomeAmount": "Income amount",
      "employerName": "Employer name",
      "jobTitle": "Job title",
      "durationMonths": "Months at",
      "durationYears": "Years at",
      "continue": "Continue"
    },
    "ApplicantEditPersonalPage": {
      "title": "Edit your personal details",
      "subtitle": "Update your personal information if there are any changes or corrections needed.",
      "firstName": "First name",
      "lastName": "Last name",
      "phone": "Phone",
      "email": "Email",
      "cancel": "Cancel",
      "save": "Save"
    },
    "ApplicantEditResidencePage": {
      "title": "Edit your residence details",
      "subtitle": "Make any necessary updates to your residence information to keep it current.",
      "housingType": "Housing type",
      "housingAmount": "Housing amount",
      "residenceLineOne": "Address",
      "residenceLineTwo": "Apt, unit",
      "residenceCity": "City",
      "residenceState": "State",
      "zip": "Zip",
      "duration": "Duration",
      "previousResidence": "Previous residence",
      "cancel": "Cancel",
      "save": "Save"
    },
    "ApplicantEditEmploymentPage": {
      "title": "Edit your employment details",
      "subtitle": "Review and update your employment information to ensure it is accurate.",
      "employmentStatus": "Employment status",
      "type": "Type",
      "employerName": "Employer name",
      "jobTitle": "Job title",
      "grossAnnualIncome": "Gross annual income",
      "duration": "Duration",
      "previousEmployment": "Previous employment",
      "cancel": "Cancel",
      "save": "Save"
    },
    "ApplicantEditIncomePage": {
      "title": "Edit your income details",
      "subtitle": "Provide any updates to your income information to reflect your current financial picture.",
      "incomeType": "Income type",
      "incomeFrequency": "Income frequency",
      "additionalIncome": "Additional income",
      "incomeAmount": "Income amount",
      "employerName": "Employer name",
      "jobTitle": "Job title",
      "durationMonths": "Months at",
      "durationYears": "Years at",
      "cancel": "Cancel",
      "save": "Save"
    },
    "ApplicantReviewPage": {
      "title": "Review your application details",
      "subtitle": "Take a moment to review all the information you've provided to ensure accuracy.",
      "personal": "Personal",
      "residence": "Residence",
      "employment": "Employment",
      "income": "Income",
      "additionalIncome": "Additional income",
      "firstName": "First name",
      "lastName": "Last name",
      "phone": "Phone",
      "email": "Email",
      "type": "Type",
      "address": "Address",
      "amount": "Amount",
      "duration": "Duration",
      "status": "Status",
      "frequency": "Frequency",
      "edit": "Edit",
      "continue": "Continue"
    },
    "ApplicantSubmitPage": {
      "title": "Finalize and submit your application",
      "subtitle": "Confirm all your details and submit your application to complete the process.",
      "coapplicant": "Co-applicant",
      "dateOfBirth": "Date of birth",
      "socialSecurityNumber": "Social security number (optional)",
      "ssnDescription": "Providing your Social Security Number now expedites the process and helps us lock in the most accurate rates. All information is securely encrypted.",
      "coapplicantSsnDescription": "Providing their Social Security Number now expedites the process and helps us lock in the most accurate rates. All information is securely encrypted.",
      "agreeToFollowing": "I agree to the following:",
      "agreeToFollowingCoapplicant": "I and the co-applicant agree to the following:",
      "submit": "Submit"
    },
    "ApplicantSuccessPage": {
      "title": "Your application was successfully submitted!",
      "subtitle": "While we review your application, please continue to upload your required verification documents to progress your application.",
      "dashboard": "Dashboard"
    },
    "CoapplicantRelationshipPage": {
      "title": "Specify relationship to applicant",
      "subtitle": "Indicate the relationship between you and the co-applicant to help us understand your connection.",
      "spouse": "Spouse",
      "relative": "Relative",
      "friend": "Friend",
      "coworker": "Coworker",
      "other": "Other",
      "continue": "Continue"
    },
    "CoapplicantPersonalDetailsPage": {
      "title": "Enter their personal details",
      "subtitle": "Provide the co-applicant's personal information to continue with your application.",
      "firstName": "First name",
      "lastName": "Last name",
      "phone": "Phone",
      "email": "Email",
      "continue": "Continue"
    },
    "CoapplicantResidenceRelationshipPage": {
      "title": "Do they live with the Applicant?",
      "subtitle": "Indicate if you both live at the same residence, to help us understand your living situation and expedite the next steps.",
      "yes": "Yes",
      "no": "No",
      "continue": "Continue"
    },
    "CoapplicantSameResidencePage": {
      "title": "Enter their residence details",
      "subtitle": "Provide the portion of the housing payment that only the co-applicant is responsible for.",
      "coapplicantHousingAmount": "Co-applicant housing amount",
      "continue": "Continue"
    },
    "CoapplicantDifferentResidenceTypePage": {
      "title": "Select their residence type",
      "subtitle": "Choose the type of residence that best describes their current living situation.",
      "continue": "Continue",
      "own": "Own",
      "rent": "Rent",
      "other": "Other"
    },
    "CoapplicantDifferentResidencePage": {
      "title": "Enter their residence details",
      "subtitle": "Provide their address and the portion of the housing payment that only the co-applicant is responsible for.",
      "continue": "Continue",
      "housingAmount": "Co-applicant housing amount",
      "residenceLineOne": "Address",
      "residenceLineTwo": "Apt, unit",
      "residenceCity": "City",
      "residenceState": "State",
      "zip": "Zip"
    },
    "CoapplicantResidenceDurationPage": {
      "title": "Have they lived here for more than two years?",
      "subtitle": "If they have lived at their current address for less than two years, we'll need their previous residence details.",
      "yes": "Yes",
      "no": "No",
      "continue": "Continue"
    },
    "CoapplicantPreviousResidencePage": {
      "title": "Enter previous residence details",
      "subtitle": "Provide their previous address and other details to help us verify their previous residence.",
      "continue": "Continue",
      "residenceLineOne": "Address",
      "residenceLineTwo": "Apt, unit",
      "residenceCity": "City",
      "residenceState": "State",
      "zip": "Zip"
    },
    "CoapplicantEmploymentStatusPage": {
      "title": "Select their employment status",
      "subtitle": "Choose whether they are currently employed or not employed to help us understand their financial picture.",
      "yes": "Employed",
      "no": "Not employed",
      "continue": "Continue"
    },
    "CoapplicantEmploymentTypePage": {
      "title": "Specify their employment type",
      "subtitle": "Indicate the option that best describes their financial picture. If they earn additional income, you can claim it in the next steps.",
      "fullTime": "Full time",
      "partTime": "Part time",
      "selfEmployed": "Self-employed",
      "military": "Military",
      "continue": "Continue"
    },
    "CoapplicantUnemploymentTypePage": {
      "title": "Specify their employment type",
      "subtitle": "Indicate the option that best describes their financial picture. If they earn additional income, you can claim it in the next steps.",
      "disability": "Disability",
      "homemaker": "Homemaker",
      "retired": "Retired",
      "student": "Student",
      "other": "Other",
      "continue": "Continue"
    },
    "CoapplicantEmploymentDetailsPage": {
      "title": "Enter their employment details",
      "subtitle": "Provide information about their employer, job title, and income to help us better understand their financial picture.",
      "employerName": "Employer name",
      "jobTitle": "Job title",
      "grossAnnualIncome": "Gross annual income",
      "continue": "Continue"
    },
    "CoapplicantUnemploymentDetailsPage": {
      "title": "Enter their current income",
      "subtitle": "Provide information about their income to better help us understand their financial picture.",
      "grossAnnualIncome": "Gross annual income",
      "continue": "Continue"
    },
    "CoapplicantEmploymentDurationPage": {
      "title": "Have they worked here for more than a year?",
      "subtitle": "If they have worked at their current employer for less than a year, we'll need their previous employment details.",
      "yes": "Yes",
      "no": "No",
      "continue": "Continue"
    },
    "CoapplicantPreviousEmploymentPage": {
      "title": "Provide their previous employment",
      "subtitle": "Provide their previous employment and other details to help us verify their previous employment.",
      "employmentType": "Employment type",
      "employerName": "Employer name",
      "jobTitle": "Job title",
      "grossAnnualIncome": "Gross annual income",
      "continue": "Continue"
    },
    "CoapplicantAdditionalIncomePage": {
      "title": "Do they have additional income?",
      "subtitle": "Let us know if they have any additional sources of income to help us better understand their financial picture.",
      "yes": "Yes",
      "no": "No",
      "continue": "Continue"
    },
    "CoapplicantIncomeDetailsPage": {
      "title": "Provide their income details",
      "subtitle": "Enter the details of their additional income to ensure we have a complete picture of their finances.",
      "incomeType": "Income type",
      "incomeFrequency": "Income frequency",
      "incomeAmount": "Income amount",
      "employerName": "Employer name",
      "jobTitle": "Job title",
      "durationMonths": "Months at",
      "durationYears": "Years at",
      "continue": "Continue"
    },
    "CoapplicantEditPersonalPage": {
      "title": "Edit their personal details",
      "subtitle": "Update their personal information if there are any changes or corrections needed.",
      "firstName": "First name",
      "lastName": "Last name",
      "phone": "Phone",
      "email": "Email",
      "cancel": "Cancel",
      "save": "Save"
    },
    "CoapplicantEditResidencePage": {
      "title": "Edit their residence details",
      "subtitle": "Make any necessary updates to their residence information to keep it current.",
      "housingType": "Housing type",
      "housingAmount": "Housing amount",
      "residenceLineOne": "Address",
      "residenceLineTwo": "Apt, unit",
      "residenceCity": "City",
      "residenceState": "State",
      "zip": "Zip",
      "duration": "Duration",
      "previousResidence": "Previous residence",
      "cancel": "Cancel",
      "save": "Save"
    },
    "CoapplicantEditEmploymentPage": {
      "title": "Edit their employment details",
      "subtitle": "Review and update their employment information to ensure it is accurate.",
      "employmentStatus": "Employment status",
      "type": "Type",
      "employerName": "Employer name",
      "jobTitle": "Job title",
      "grossAnnualIncome": "Gross annual income",
      "duration": "Duration",
      "previousEmployment": "Previous employment",
      "cancel": "Cancel",
      "save": "Save"
    },
    "CoapplicantEditIncomePage": {
      "title": "Edit their income details",
      "subtitle": "Provide any updates to their income information to reflect their current financial picture.",
      "incomeType": "Income type",
      "incomeFrequency": "Income frequency",
      "additionalIncome": "Additional income",
      "incomeAmount": "Income amount",
      "employerName": "Employer name",
      "jobTitle": "Job title",
      "durationMonths": "Months at",
      "durationYears": "Years at",
      "cancel": "Cancel",
      "save": "Save"
    },
    "CoapplicantReviewPage": {
      "title": "Review their application details",
      "subtitle": "Take a moment to review all the information provided to ensure accuracy.",
      "personal": "Personal",
      "residence": "Residence",
      "employment": "Employment",
      "income": "Income",
      "additionalIncome": "Additional income",
      "firstName": "First name",
      "lastName": "Last name",
      "phone": "Phone",
      "email": "Email",
      "type": "Type",
      "address": "Address",
      "amount": "Amount",
      "duration": "Duration",
      "status": "Status",
      "frequency": "Frequency",
      "edit": "Edit",
      "continue": "Continue"
    },
    "LoanDocumentPage": {
      "title": "Welcome, {{firstName}}!",
      "subtitle": "If you purchased a Vehicle Service Contract or GAP policy at your dealership, there is a great chance we can save you money on your protection products and provide thousands in refunds.",
      "continue": "Continue",
      "resume": "Resume"
    },
    "LoanDocumentListPage": {
      "continue": "Continue",
      "edit": "Edit",
      "gap": "GAP contract",
      "numberOfDocs_one": "{{count}} document",
      "numberOfDocs_other": "{{count}} documents",
      "numberOfDocs_zero": "{{count}} documents",
      "ric": "Retail installment contract",
      "subtitle": "These documents are contained in your loan package that you received from your dealer. If you can't locate them, contact your selling dealership to ask for a copy of your loan documents.",
      "tapToUpload": "Tap to upload",
      "title": "Upload Protection Documents",
      "upload": "Upload",
      "uploadFailed": "Upload request failed. Please try again later.",
      "uploadTimeout": "Request timed out. Please check your connnection and try again.",
      "vsc": "Service contract"
    },
    "LoanDocumentUploadPage": {
      "exampleDocument": "Example document",
      "cancel": "Cancel",
      "tooltip": "If you are unsure about if you have the right document or you have multiple documents, upload them all and we will locate the appropriate document.",
      "remove": "Remove",
      "submit": "Submit",
      "uploaded": "Already uploaded"
    },
    "LoanDocumentUploadGAPPage": {
      "title": "GAP contract",
      "subtitle": "This document is typically several pages long, and details information about you, your vehicle, the lienholder and the terms of the policy. A legible copy of the first page is the most important."
    },
    "LoanDocumentUploadRICPage": {
      "title": "Retail installment contract",
      "subtitle": "This document is typically 4-5 pages long and details the loan / financing terms of your car loan. The first and second pages are usually the most important."
    },
    "LoanDocumentUploadVSCPage": {
      "title": "Service contract",
      "subtitle": "This document is typically several pages long, and details information about you, your vehicle, the lienholder and the coverage of your service contract (mileage, term, etc)."
    },
    "LoanDocumentUploadAllPage": {
      "exampleDocumentsTitle": "Example documents:",
      "exampleGAPDocument": "GAP document",
      "exampleRICDocument": "RIC document",
      "exampleVSCDocument": "VSC document",
      "submit": "Submit",
      "subtitle": "Upload your loan / dealer documents and we will analyze your deal and provide a customized savings report detailing your eligible savings and refund amount.",
      "subtitleToo": "Not sure what you have? No problem, upload what you have and we'll sort it out for you!",
      "title": "Savings this simple."
    },
    "LoanDocumentMileagePage": {
      "mileage": "Mileage",
      "submit": "Submit",
      "subtitle": "Please provide your current mileage to accurately calculate your savings and refund amount.",
      "title": "Current vehicle mileage"
    },
    "LoanDocumentSuccessPage": {
      "title": "Your documents were successfully submitted!",
      "subtitle": "We are searching for savings and will follow up shortly with your customized savings report.",
      "submit": "Dashboard"
    },
    "VerificationPage": {
      "title": "Let's collect your required verification documents",
      "subtitle": "This will help verify the accuracy of your application information and expedite the next steps in funding your application.",
      "continue": "Continue"
    },
    "VerificationDocumentListPage": {
      "title": "Upload verification documents",
      "subtitle": "Please upload any and all required documents to verify your information and complete your application."
    },
    "VerificationUploadPage": {
      "required": "Required",
      "edit": "Edit",
      "upload": "Upload",
      "cancel": "Cancel",
      "submit": "Submit",
      "uploadFailed": "Upload request failed. Please try again later.",
      "uploadTimeout": "Request timed out. Please check your connnection and try again."
    },
    "VehicleConfirmationPage": {
      "title": "Confirm vehicle details",
      "subtitle": "To deliver you the most accurate rates, please confirm we have the correct vehicle details.",
      "selectYear": "Select year",
      "selectMake": "Select make",
      "selectModel": "Select model",
      "selectTrim": "Select trim",
      "confirm": "Confirm"
    }
  }
}
